/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageHeader from '../../layouts/page-header/PageHeader';
import { useTranslation } from 'react-i18next';
import BlogSidebar from './sidebar';
import moment from 'moment';
import '../blog/blog.scss';
import { formatMonth } from '../../data/format-month';
import replaceWithSpace from '../../data/replace';
import Loading from '../../component/Loading';
import { HiOutlineEye } from 'react-icons/hi2';
import { bilimMerkezAPI } from '../../api';

function BlogSingle() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  // const [latestNews, setLatestNews] = useState([]);

  const lang = language === 'tk' ? 'tm' : language;

  const formatDate = (date) => {
    const month = date?.split('T')[0]?.split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(
      'DD, YYYY, HH:mm'
    )}`;
  };

  const getLocalizedTitle = (item) =>
    item?.[`title_${lang}`] || item?.title_tm || '';

  const getLocalizedContent = (item) =>
    item?.[`content_${lang}`] || item?.content_tm || '';

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchAnnouncement = async () => {
      // setData(undefined); // ← ДОБАВЬ ЭТО
      setLoading(true);
      try {
        const res = await bilimMerkezAPI.get(`/notices/${slug}`, {
          params: { lang },
        });
        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncement();
  }, [slug, lang]);

  // useEffect(() => {
  //   const fetchLatestNews = async () => {
  //     try {
  //       const res = await bilimMerkezAPI.get(`/notices`, {
  //         params: { offset: 0, limit: 20, lang },
  //       });
  //       // setLatestNews(res.data?.results || []);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchLatestNews();
  // }, [lang]);

  return (
    <div className="site-content">
      <PageHeader
        colSize="col-md-10"
        title={t('announcements')}
        PagaHeaderBg="/images/bg.svg"
        breadCrumbItems={[{ label: t('home'), path: '/' }]}
      />

      <div className="content-wrapper page-template">
        <Container>
          <Row className="justify-content-center">
            {loading ? (
              <div className="flex justify-center items-center w-full">
                <Loading style={{ width: '10%' }} />
              </div>
            ) : (
              <Col xl={8} lg={12}>
                <article className="about-post blog-post">
                  <div className="entry-content">
                    <div className="entry-meta">
                      <ul>
                        <li key="meta-calendar">
                          <img src="/images/calendar.svg" alt="calendar" />
                        </li>
                        <li key="meta-date" className="entry-meta-date">
                          <div>
                            {data?.published_date
                              ? formatDate(data?.published_date)
                              : ''}
                            <div style={{ width: '32px' }}></div>
                            <HiOutlineEye size={22} />
                            {data?.views}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <h4 className="entry-title pt-2">
                      {getLocalizedTitle(data)}
                    </h4>
                  </div>

                  <div className="post-image">
                    {data?.image && (
                      <img
                        className="w-100"
                        src={data?.image}
                        alt="announcement"
                      />
                    )}
                  </div>

                  <div className="entry-content">
                    <div className="entry-description">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: replaceWithSpace(getLocalizedContent(data)),
                        }}
                      ></div>
                    </div>
                  </div>
                </article>
              </Col>
            )}
            {!loading && (
              <Col xl={4} lg={8} md={8}>
                <BlogSidebar news_id={data?.slug} />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default BlogSingle;
